import React, { useState } from 'react';
import classes from './GameList.module.scss';
import NumberCircle from '../NumberCircle/NumberCircle';
import { useTheme } from '../../utils/ThemeContext';

export default function GameList({ title, games, onGameClick, activeGame, hoverColor }) {
    const [hoveredGame, setHoveredGame] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    const { theme } = useTheme();

    const getThemeColor = () => {
        if (!hoverColor || typeof hoverColor !== 'string') {
            return "gray";
        }
        switch (theme.themeName) {
            case "pick 3":
            case "lotto 5/90":
            case "lotto 4/48":
            case "Lotto 6/49":
                return hoverColor;
            default:
                return "gray";
        }
    };


    return (
        <>
            <div className={classes.gameListContainer}>
                <span className={`${classes.gameList_title} `}
                    onClick={() => setIsOpen(!isOpen)}>
                    {title}
                </span>
                <ul
                    className={`${classes.gameList}  ${games.length > 0 ? classes[games[0].type] : ""}`}
                >
                    {games.map((game, index) => (
                        <li
                            key={index}
                            className={`${classes.gameItems} ${activeGame === game.GameName ? classes.active : ""}`}
                            onClick={() => onGameClick(game.GameName)}
                            onMouseEnter={() => setHoveredGame(game.GameName)}
                            onMouseLeave={() => setHoveredGame(null)}
                            style={{
                                background:
                                    activeGame === game.GameName
                                        ? getThemeColor()
                                        : hoveredGame === game.GameName
                                            ? getThemeColor()
                                            : "transparent",
                            }}
                        >
                            <NumberCircle {...game} />
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
}
